import { makeObservable, action, observable } from 'mobx';
import MkMessNotifRequests from "Utils/Requests/MkMessNotifRequests";
import AppStore from 'Stores/AppStore';

class MkExistentMessageViewStore {
    listLoading;
    /** @type {number | null} */
    currentMessageId;
    returnToMessageList;
    cancelingUserInfo;

    constructor() {
        makeObservable(this, {
            listLoading: observable,
            returnToMessageList: observable
        });

        this.listLoading = false;
    }

    SetUserInfoForCancelMessageModal = action((userLid, userName) => {
        this.cancelingUserInfo = {
            Lid: userLid,
            Name: userName
        };
    });

    ResetReturnToMessageList = action(() => {
        this.returnToMessageList = false;
    });

    DeleteMessage = action(() => {
        this.listLoading = true;
        MkMessNotifRequests.DeleteMessages([this.currentMessageId])
            .then(action(() => {
                this.returnToMessageList = true;

                this.ShowAlertAfterCancellation({
                    type: 'success',
                    text: 'Сообщение успешно удалено'
                });
            }))
            .finally(action(() => this.listLoading = false));
    });

    CancelMessage = action(() => {
        MkMessNotifRequests.CancelMessageForUser(this.currentMessageId, this.cancelingUserInfo.Lid)
            .then(action(() => {
                this.GetViewList();
            }));
    });

    SetTableStore(store) {
        this.tableStore = store;
    }

    GetViewList = action(pageToSet => {
        if (pageToSet == null)
            pageToSet = 1;

        let { elementsPerPage } = this.tableStore.paginationInfo;

        this.listLoading = true;
        MkMessNotifRequests.GetMessageViewInfo(this.currentMessageId, (pageToSet - 1) * elementsPerPage, elementsPerPage)
            .then(action(data => {
                this.messageData = data;

                if (this.messageData.body === null)
                    this.messageData.body = '';

                if (!this.tableStore.HandlePagination(this.SetPageData.bind(this), data.totalInfosCount, pageToSet, page => this.GetUsers(filterString, page)))
                    return;

                this.listLoading = false;
                this.tableStore.data = data.viewInfos;

                AppStore.pageTitleAdditionalInfo = `. Тема: ${data.title}`;
            }));
    });

    SetPageData(pageToSet) {
        window.history.pushState(null, `Тема: ${this.messageData.title}`, `${window.SmrLocation}/mkMessaging/viewMessage?messageId=${this.currentMessageId}&page=${pageToSet}`);

        AppStore.SetLastPageInfo({
            pageTitle: 'viewMessage',
            params: {
                page: `${pageToSet}`
            }
        });
    }
}

export default new MkExistentMessageViewStore();